var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.type==='box')?_c('div',[_c('BoxEdit',{attrs:{"item":_vm.item}},[_vm._v(_vm._s(_vm.layer1))])],1):_c('div',[_c('div',[_vm._v("--------------------------------------")]),_c('BoxEdit',{attrs:{"item":_vm.layer1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }